export default __webpack_public_path__ + "static/media/notification.768659fe.svg";